const initialState = {
    "catalogoPregunta1": [],
    "catalogoPregunta2": [],
    "objetoPregunta1": {},
    "objetoPregunta2": {}
}

export function catalogosRdc(state = initialState, action) {
    switch (action.type) {
        case "CARGAR_CATALOGO_PREGUNTAS": 
            var aPregunta1 = [];
            for (var pregunta of Object.keys(action.catalogoPregunta1) ) {
                aPregunta1.push({ "id": pregunta, "descripcion": action.catalogoPregunta1[pregunta] });
            }
            
            var aPregunta2 = [];
            for (var pregunta of Object.keys(action.catalogoPregunta2) ) {
                aPregunta2.push({ "id": pregunta, "descripcion": action.catalogoPregunta2[pregunta] });
            }
            
            return {...state,
                "objetoPregunta1": action.catalogoPregunta1,
                "objetoPregunta2": action.catalogoPregunta2,
                "catalogoPregunta1": aPregunta1,
                "catalogoPregunta2": aPregunta2
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/catalogos/reducer.js